import { useCallback, useEffect, useSyncExternalStore } from 'react';
import { toLoading, toEmpty } from '../resolvers/definition/resolverState';
import { useKey } from './useKey';
import { usePulseClient as usePulseClientContext } from './PulseContext';
export const initial = Object.freeze(toLoading()());
export const skipped = toEmpty()();
export const emptyInitialParams = Object.freeze({});
export const usePulseClient = warnIfMissing => {
  const client = usePulseClientContext();
  if (process.env.NODE_ENV === 'development') {
    // This is safe — our bundler checks this condition at build time
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (!client && warnIfMissing) {
        console.error('Pulse client was not found in context — did you forget to provide it?');
      }
    }, [client, warnIfMissing]);
  }
  return client;
};
export const useParseOptions = (resource, options) => {
  const params = (options === null || options === void 0 ? void 0 : options.params) || emptyInitialParams;
  const skip = !!(options !== null && options !== void 0 && options.skip);
  const pollInterval = options === null || options === void 0 ? void 0 : options.pollInterval;
  const instanceKey = useKey(resource, params);
  return {
    params,
    skip,
    pollInterval,
    instanceKey
  };
};
export const useSyncResource = (getSnapshot, instanceKey, resource, params, skip, pollInterval, client) => {
  const subscribe = useCallback(callback => {
    if (skip || !client) {
      return () => {};
    }
    return client.watch({
      resource,
      params,
      instanceKey,
      pollInterval
    }, callback);
  },
  // instanceKey is a proxy for params and resource type changing
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [client, instanceKey, pollInterval, skip]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};